
import * as _ from "lodash"
import Vue from "vue"
import Component from "vue-class-component"
import {Prop} from "vue-property-decorator"
import ChangeRateWidget from "@/superannuation/ChangeRateWidget.vue"
import {MetricAggregated} from "@/cube/metric-data"
import AnimatedNumber from "@/ui/AnimatedNumber.vue"

@Component({components: {AnimatedNumber, ChangeRateWidget}})
export default class CircularProgressWidget extends Vue {
  @Prop()
  metricData: MetricAggregated

  @Prop({default: false})
  reverse: boolean

  get progressColor() {
    return this.reverse ? "negative" : "alt-1-color"
  }

  get amountPercent() {
    return _.round((this.metricData.end?.amountPercent ?? 0) * 100)
  }

  get amount() {
    return this.metricData.end?.amount
  }
}
